// Dependencies
import Cases      from 'layouts/cases';
import References from 'layouts/references';


class PageCases {
  /**
   * Constructor: Cases Page Constructor.
   */
  constructor() {
    // Root
    this._root = document.querySelector('[layout="page-cases"]');

    // Dependencies
    this.Cases      = new Cases();
    this.References = new References();
  }


  /**
   * Resize: Resize the page.
   */
  resize() {
    this.Cases.resize();
    this.References.resize();
  }
}

export default PageCases;


// WEBPACK FOOTER //
// ./src/js/templates/page-cases.js